import axios from 'axios';
import { getAccessTokenBrowser } from 'helpers/auth';
import { getApiUrl } from './constants';

const REQUEST_TIMEOUT_MS = 10000;

export type GetProfilesResult = {
	firstName: string;
	lastName: string;
	address: {
		line1: string;
		line2: string;
		postNumber: string;
		city: string;
		country: string;
		secretAddress: boolean;
	};
	membership: {
		id: string;
		startDate: string;
		category: string;
	};
	branch: {
		id: string;
		name: string;
	};
	notificationCount: number;
	education: {
		start: string;
		completed: string;
		expectedCompleted: string;
		name: string;
		school: string;
	};
	employment: {
		date: string;
		employer: {
			pNumber: string;
			postCode: string;
			cvr: string;
			name: string;
			agreement: {
				id: number;
				name: string;
				link: string;
			};
		};
		jobTitle: string;
	};
	duties: string[];
	privateContact: {
		email: string;
		phone: string;
	};
	workContact: {
		email: string;
		phone: string;
	};
	insurance: string; // TODO: Make to an array
	representatives: {
		firstName: string;
		lastName: string;
		duty: string;
		workContactInformation: {
			email: string;
			phone: string;
		};
		privateContactInformation: {
			email: string;
			phone: string;
		};
	}[];
	canSeeUnionRepresentativeWebsite: boolean;
};

export type RequestHeaders = {
	hostname: string;
	Authorization?: string;
};

export const getProfilesAdapter = async (hostname: string): Promise<GetProfilesResult> => {
	const accessToken = await getAccessTokenBrowser();
	const headers: RequestHeaders = {
		hostname,
	};
	if (accessToken) {
		headers.Authorization = 'Bearer ' + accessToken;
	}
	const { href } = getApiUrl('Profile');
	// Bounded so a hung request cannot strand the profile/audience chain. Without a
	// timeout this waited for the browser default and left audiences unresolved.
	const { data: profiles } = await axios.get<GetProfilesResult>(href, { headers: headers, timeout: REQUEST_TIMEOUT_MS });
	return profiles;
};
